<template>
  <b-tooltip :append-to-body="appendToBody" :triggers="['click', 'hover', 'focus']" auto-close
             multilined position="is-right"
             :position="position"
             size="is-large"
             type="is-light">
    <b-icon icon="question-circle" size="is-medium" type="is-info" @hover="showCard"></b-icon>
    <template v-slot:content>
      <div class="card white">
        <div v-if="cardImage && imageEnabled" class="card-image">
          <figure class="image is-1by1">
            <img :alt="cardImageAlt" :src="cardImage">
          </figure>
        </div>
        <div class="card-content">
          <div class="content">
            {{ cardText }}
          </div>
        </div>
      </div>
    </template>
  </b-tooltip>
</template>
<script>
export default {
  name: "info-icon-and-card",
  props: {
    cardText: {
      type: String,
      default: 'No text provided',
    },
    cardImage: {
      type: String,
      default: null,
    },
    cardImageAlt: {
      type: String,
      default: "Placeholder image",
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
    position: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showCard: false,
      imageEnabled: true,
    };
  },
}
</script>
<style lang="scss" scoped>

</style>